if (!customElements.get('ideal-footer')) {
  customElements.define('ideal-footer', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      this.mobile = matchMedia('(max-width: 749px)');
      this.menus = [...this.querySelectorAll('[data-footer-menu]')];
      this.sync = () => {
        this.menus.forEach(menu => {
          menu.open = !this.mobile.matches;
          menu.querySelector('summary').tabIndex = this.mobile.matches ? 0 : -1;
        });
      };
      this.sync();
      this.mobile.addEventListener('change', this.sync, { signal: this.abort.signal });
      this.addEventListener('click', event => {
        if (!this.mobile.matches && event.target.closest('.ideal-footer-menu-summary')) event.preventDefault();
      }, { signal: this.abort.signal });
      document.addEventListener('shopify:block:select', event => {
        if (!this.contains(event.target)) return;
        const menu = event.target.closest('.site-footer-block-item')?.querySelector('[data-footer-menu]');
        if (menu) menu.open = true;
      }, { signal: this.abort.signal });
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}
